// @ts-strict-ignore
/**
 * @fileoverview POST handler for the "/engagement/segments/:app_group_id/mark_as_unarchived" endpoint
 */
import type { SuppressionListErrors } from "@dashboardApi/apis/engagementSegmentsMarkAsArchived/types";

import fetch from "@lib/fetch";

import { createMutationFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createMutationFetcherFunctionWithShadowError";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementSegmentsMarkAsUnarchivedCacheKeys } from "./constants";
import type {
  SegmentsRestoreResult,
  SegmentsUndoArchiveResult,
  SegmentsRestoreProps,
  SegmentsUndoArchiveProps,
} from "./types";

export const postEngagementSegmentsMarkAsUnarchived = reactQueryMutationAdapter(
  engagementSegmentsMarkAsUnarchivedCacheKeys,
  createMutationFetcherFunctionWithShadowError<SuppressionListErrors>()(
    (
      props: SegmentsRestoreProps | SegmentsUndoArchiveProps
    ): Promise<SegmentsRestoreResult | SegmentsUndoArchiveResult> => {
      const params = {
        app_group_id: props.app_group_id,
        segment_ids: props.segment_ids,
        type: props.type,
      };

      if ("undo_identifier" in props) {
        params["undo_identifier"] = props.undo_identifier;
      } else {
        params["campaigns_to_unarchive"] = props.campaigns_to_unarchive;
        params["cards_to_unarchive"] = props.cards_to_unarchive;
        params["workflows_to_unarchive"] = props.workflows_to_unarchive;
        params["reenable_analytics"] = props.reenable_analytics;
      }

      return fetch(
        `/engagement/segments/${props.app_group_id}/mark_as_unarchived`,
        "POST",
        params,
        {},
        {
          propagateFetchRequestError: false,
        }
      );
    }
  )
);
